import React, { FC } from 'react';
import MuiGrow, { GrowProps as MuiGrowProps } from '@mui/material/Grow';
import { BpDesignSystem } from '../../types';

export type GrowProps = BpDesignSystem.PropsWithChildren<MuiGrowProps & {}>;

export const Grow: FC<GrowProps> = ({ dataTest, ...props }) => <MuiGrow data-test={dataTest} {...props} />;
